export const isInExtension = ({ isInExtension: inExtension = false } = {}) =>
  inExtension;

export const getExtensionTitle = ({ extension = {} } = {}) =>
  extension.title ? `Extension: ${extension.title}` : '';
